import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import { IconPlus } from "@tabler/icons-react";
import { useState, type FC } from "react";
import { MenuTrigger } from "react-aria-components";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";
import { useAppSelector } from "../../../hooks/hook.js";
import { selectFountainIntegration } from "../../integrations/integrationsSlice.js";
import { CreateProjectViaFountainModal } from "./createProjectViaFountainModal.js";

interface CreateJobOpeningButtonProps {
  onClickCreate: () => void;
}

export const CreateJobOpeningButton: FC<CreateJobOpeningButtonProps> = ({
  onClickCreate,
}) => {
  const fountainIntegration = useAppSelector(selectFountainIntegration);
  const [isFountainModalOpen, setIsFountainModalOpen] = useState(false);

  if (fountainIntegration) {
    return (
      <Can
        I={PermissionActions.CREATE}
        a={PermissionSubjects.JOB_OPENINGS}
        passThrough={true}
      >
        {(allowed) => (
          <>
            <MenuTrigger>
              <Button
                variant={ButtonVariant.Primary}
                icon={<IconPlus className="h-4 w-4" />}
                isDisabled={!allowed}
              >
                Create job opening
              </Button>
              <SimpleMenuPopover placement="bottom end">
                <SimpleMenu aria-label="Create job opening">
                  <SimpleMenuItem
                    onAction={() => {
                      onClickCreate();
                    }}
                  >
                    From a job description
                  </SimpleMenuItem>
                  <SimpleMenuItem
                    onAction={() => {
                      setIsFountainModalOpen(true);
                    }}
                  >
                    From a Fountain position
                  </SimpleMenuItem>
                </SimpleMenu>
              </SimpleMenuPopover>
            </MenuTrigger>
            <CreateProjectViaFountainModal
              isOpen={isFountainModalOpen}
              onClose={() => {
                setIsFountainModalOpen(false);
              }}
              fountainIntegration={fountainIntegration}
            />
          </>
        )}
      </Can>
    );
  }

  return (
    <Can I={PermissionActions.CREATE} a={PermissionSubjects.JOB_OPENINGS}>
      {(allowed) => (
        <Button
          variant={ButtonVariant.Primary}
          onClick={onClickCreate}
          icon={<IconPlus className="h-4 w-4" />}
          isDisabled={!allowed}
        >
          Create job opening
        </Button>
      )}
    </Can>
  );
};
